import { Box, Grid, Stack, Typography } from "@mui/material"
import { safeFormatDate } from "../../../utils/utilityFunctions"
import { DlspTable } from "./DlspTable"
import { mahiBffUrl } from "../../../data/hikoFetch"
import useFetchJson from "../../../data/useFetchJson"
import { useEffect } from "react"
import { DlspTitleTypography } from "../../styled/DlspTitleTypography"
import EmojiNatureIcon from '@mui/icons-material/EmojiNature';
import UpdatedGalleryViewer from "../../upload/UpdatedGalleryViewer"

const bffBaseUrl = mahiBffUrl()

export function DlspFieldInspectionPanel({taskDetails}) {

    const bffGetAllPath = `/bff/decommissioned-lines-service/api/decommissioned-lines/field-inspection-image/get-all`
    const { data: allImages, load: loadAllImages  } = useFetchJson(bffGetAllPath)

    useEffect(() => {
        if (!taskDetails?.decomICP?.icp) {
            return
        }
        const loadImagesParams = { params: { icp: taskDetails?.decomICP?.icp } }
        loadAllImages(loadImagesParams) // run in background

    }, [taskDetails, loadAllImages])

    return (
        <>
            <Box>
                <FieldInspectionDetails
                    fieldChecklist={taskDetails?.decomICP?.fieldChecklist}
                    inspectedBy={taskDetails?.decomICP?.fieldInspBy}
                    inspectionDate={taskDetails?.decomICP?.fieldInspDate}
                />
            </Box>
            <Box sx={{mt:4}}>

                <DlspTitleTypography variant="h4" color="secondary">Field Inspection Photos</DlspTitleTypography>
                <UpdatedGalleryViewer documents={allImages} bffBase={bffBaseUrl} options={{readOnly: true}} />
            </Box>
        </>
    )
}

function FieldInspectionDetails({inspectedBy, inspectionDate, fieldChecklist}) {

    const leftTableRows = []
    leftTableRows.push({label: 'Field Inspection Complete',                text: fieldChecklist?.fieldInspectionComplete                    })
    leftTableRows.push({
        label: fieldChecklist?.fieldInspectionPriority === 'Yes'
        ? 
            <Stack direction="row" sx={{justifyContent:"flex-end", alignItems:"center"}}>
                <EmojiNatureIcon sx={{pr:1}} fontSize="medium"/> 
                <p>Priority Field QA</p>
            </Stack> 
        :
            <>
                Priority Field QA
            </>
        , text: fieldChecklist?.fieldInspectionPriority
    })
    leftTableRows.push({label: 'Field Inspection Comments',                text: fieldChecklist?.fieldInspectionComments                    })

    const rightTableRows = []
    
    
    return (
        <Box sx={{my: 2}}>
        {
            (!inspectedBy || !inspectionDate || !fieldChecklist)
            ?
            <></>
            :
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body2"><strong>{inspectedBy}</strong></Typography>
                    <Typography variant="body2"><strong>{safeFormatDate(inspectionDate, 'd MMMM yyyy HH:mm a')}</strong></Typography>

                </Grid>
                <Grid item md={6}>
                    <DlspTable rows={leftTableRows} skipHeader={true} />
                </Grid>
                <Grid item md={6}>
                    <DlspTable rows={rightTableRows} skipHeader={true} />
                    
                </Grid>
            </Grid>
        }
        </Box>
    )
}